import React from 'react';
import Certificate from '../images/certificates/Spanish Certification.jpeg';
const SpanishCertificate = () => {
  return (
    <div style={{ textAlign: 'center', marginTop: '10px' }}>
      <img
        style={{ maxWidth: '100%', height: 'auto' }}
        src={Certificate}
        alt="Spanish Certificate"
      />
    </div>
  );
};

export default SpanishCertificate;
